import { useState } from 'react';

export default function BrandingSettings() {
  const [siteName, setSiteName] = useState('SISI');
  const [primaryColor, setPrimaryColor] = useState('#EF579A');
  const [logoUrl, setLogoUrl] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSave = () => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const handleReset = () => {
    setSiteName('SISI');
    setPrimaryColor('#EF579A');
    setLogoUrl('');
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Branding Settings</h2>
        <p className="text-sm text-gray-600">Customize your site's branding and appearance</p>
      </div>

      {showSuccess && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center space-x-3">
          <i className="ri-checkbox-circle-fill text-green-600 text-xl"></i>
          <span className="text-sm text-green-800 font-medium">Settings saved successfully!</span>
        </div>
      )}

      <div className="space-y-6">
        {/* Site Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Site Name
          </label>
          <input
            type="text"
            value={siteName}
            onChange={(e) => setSiteName(e.target.value)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#EF579A] focus:border-transparent text-sm"
            placeholder="Enter site name"
          />
        </div>

        {/* Logo URL */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Logo URL (Optional)
          </label>
          <input
            type="text"
            value={logoUrl}
            onChange={(e) => setLogoUrl(e.target.value)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#EF579A] focus:border-transparent text-sm"
            placeholder="https://example.com/logo.png"
          />
          {logoUrl && (
            <div className="mt-3 p-4 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-600 mb-2">Logo Preview:</p>
              <img
                src={logoUrl}
                alt="Logo preview"
                className="h-12 object-contain"
                onError={(e) => {
                  e.currentTarget.src = 'https://via.placeholder.com/150x50?text=Invalid+Image';
                }}
              />
            </div>
          )}
        </div>

        {/* Primary Color */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Primary Color
          </label>
          <div className="flex items-center space-x-4">
            <input
              type="color"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
              className="w-16 h-12 border border-gray-300 rounded-lg cursor-pointer"
            />
            <input
              type="text"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
              className="flex-1 px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#EF579A] focus:border-transparent text-sm"
              placeholder="#EF579A"
            />
          </div>
          <p className="mt-2 text-xs text-gray-500">This color will be used for buttons, links, and accents throughout the site</p>
        </div>

        {/* Preview */}
        <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-4">Preview:</p>
          <div className="flex items-center space-x-4 mb-4">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="Logo"
                className="h-10 object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            ) : (
              <div 
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: primaryColor }}
              >
                <i className="ri-store-2-fill text-white text-xl"></i>
              </div>
            )}
            <span className="text-xl font-bold text-gray-900">{siteName}</span>
          </div>
          <button
            className="px-6 py-2.5 rounded-lg text-white font-medium text-sm whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: primaryColor }}
          >
            Sample Button
          </button>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-200">
          <button
            onClick={handleReset}
            className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium text-sm hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Reset to Default
          </button>
          <button
            onClick={handleSave}
            className="px-6 py-2.5 bg-[#EF579A] text-white rounded-lg font-medium text-sm hover:bg-[#D94A85] transition-colors whitespace-nowrap cursor-pointer"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
